export const ROLES = {
  ADMIN: "Admin",
  EMPLOYEE: "Employee",
  CO_OWNER: "Co-owner",
  BUSINESS: "Business",
  CUSTOMER: "Customer",
  BANKER: "Banker",
  LEAD: "LEAD",
};

// Helper function to get last 3 years for P&L Statement
export const getLastThreeYears = (): number[] => {
  const currentYear = new Date().getFullYear();
  return [currentYear - 1, currentYear - 2, currentYear - 3];
};

// Helper function to generate P&L document names dynamically
export const generatePLDocumentNames = (prefix: string = "YTD"): string[] => {
  const years = getLastThreeYears();
  return years.map(year => `${prefix} ${year} Profit & Loss Statement`);
};

// Helper function to generate Business Tax document names dynamically
export const generateBusinessTaxDocumentNames = (): string[] => {
  const years = getLastThreeYears();
  return years.map(year => `${year} Business Tax Returns`);
};

// Helper function to generate Personal Tax document names dynamically
export const generatePersonalTaxDocumentNames = (): string[] => {
  const years = getLastThreeYears();
  return years.map(year => `${year} Personal Tax Returns`);
};

// Helper function to generate Guaranteed Business Tax document names dynamically
export const generateGuaranteedBusinessTaxDocumentNames = (): string[] => {
  const years = getLastThreeYears();
  return years.map(year => `Guaranteed ${year} Business Tax Returns`);
};

// Helper function to generate Guaranteed Personal Tax document names dynamically
export const generateGuaranteedPersonalTaxDocumentNames = (): string[] => {
  const years = getLastThreeYears();
  return years.map(year => `Guaranteed ${year} Personal Tax Returns`);
};

// business document
export const purchaseDocumentList = [
  "LOI or Purchase Agreement",
  "Brief Description of the Project",
  ...generatePLDocumentNames("YTD"),
  ...generateBusinessTaxDocumentNames(),
  ...generatePersonalTaxDocumentNames(),
  ...generateGuaranteedBusinessTaxDocumentNames(),
  ...generateGuaranteedPersonalTaxDocumentNames(),
];
export const refinanceDocumentList = [
  "Current Loan Statement",
  "Appraisal (if available)",
  "Phase 1 (if available)",
  ...generatePLDocumentNames("Refinance YTD"),
  ...generateBusinessTaxDocumentNames(),
  ...generatePersonalTaxDocumentNames(),
  ...generateGuaranteedBusinessTaxDocumentNames(),
  ...generateGuaranteedPersonalTaxDocumentNames(),
];

export const startupDocumentList = [
  "Startup - New Project",
  "3 Year Projections",
  "Business Plan",
  "2-3 Page Whitepaper That Explains the Project",
];

export const dealsStatus = {
  New: "New",
  PendingReview: "Pending Review",
  Approved: "Approved",
  Rejected: "Rejected",
  Closed: "Closed",
  LostDeal: "Lost Deal",
}

export const LoanStatus = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  DISBURSED: "Disbursed",
}

export enum FinancialInfoStatus {
  FILE_UPLOAD = "Upload PDF",
  FILL_FORM = "Fill Form",
}

export enum SnackbarSeverity {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export const COLLATERAL_OPTIONS = [
  "",
  "Blanket Lien (All Assets)",
  "Accounts receivable",
  "Inventory – raw materials or finished goods",
  "Equipment & machinery – manufacturing tools, office equipment",
  "Furniture & fixtures – desks, shelving, etc",
  "Commercial property"
];

export const GUARANTY_OPTIONS = [
  "",
  "Business guaranty",
  "Personal guarantee"
];
